import { Observable } from 'rxjs';
import { BaseService } from './base.service';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class ReorderService extends BaseService {
  constructor(protected readonly httpClient: HttpClient) {
    super(httpClient);
  }

  update(accountId: number, type: string, ranks: any[] | {}): Observable<any[]> {
    return this.httpClient.post<any>(`reorders`, {
      reorder: { reorder_type: type, ids_to_ranks: ranks },
    });
  }
}
